import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import SectionHeader, {
  HeadingWrapper,
} from "../Atomics/SectionHeader/SectionHeader";
import { useContext, useEffect, useState } from "react";
import ChannelCard from "../Atomics/ChannelCard/ChannelCard";
import VideoCard from "../Atomics/VideoCard/VideoCard";
import { campaignFetcher } from "../../api/requests";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus, faTrophy } from "@fortawesome/free-solid-svg-icons";
import { baseURL } from "../../api/dataFetcher";
import Modal from "../Atomics/Modal";
import AddVideoToCampaignForm from "./AddVideoToCampaignForm";
import { AuthContext } from "../../context/auth";
import { ProgressBar } from "react-bootstrap";
import { faTimesCircle } from "@fortawesome/free-solid-svg-icons";
import { Link } from "react-router-dom/cjs/react-router-dom.min";
import { CategoryContextProvider } from "../../context/categories";
import { TagsContextProvider } from "../../context/tag";

const Campaign = ({
  title,
  videosBasedOnCategory,
  mine,
  more = 6,
  channelId,
  tag,
  tagId,
  categoryId,
  xs = 2,
  sm = 2,
  md = 6,
  lg = 8,
  xl = 12,
  type,
}) => {
  const [breakpoint, setBreakpoint] = useState("xl");
  const [campaigns, setCampaigns] = useState();
  const [showCampaignAdd, setShowCampaignAdd] = useState(false);
  const { isLoggedIn } = useContext(AuthContext);
  const [loading, setLoading] = useState(false);
  const [progress, setProgress] = useState(0);

  const getBreakpoint = () => {
    const width = window.innerWidth;
    if (width < 576) return "xs";
    if (width < 768) return "sm";
    if (width < 992) return "md";
    if (width < 1200) return "lg";
    return "xl";
  };

  const getCampaigns = async () => {
    try {
      const res = await campaignFetcher.getActiveCampaigns();

      setCampaigns(res);
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    getCampaigns();

    const handleResize = () => setBreakpoint(getBreakpoint());
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const getVisibleItems = () => {
    switch (breakpoint) {
      case "xs":
        return xs;
      case "sm":
        return sm;
      case "md":
        return md;
      case "lg":
        return lg;
      case "xl":
      default:
        return xl;
    }
  };

  const visibleItems = getVisibleItems();
  const visibleVideos = videosBasedOnCategory?.content_items?.slice(
    0,
    visibleItems
  );

  const selectedCampaign = campaigns?.results.find((item) =>
    title.includes(item.name)
  );

  const handleUploadClick = () => {
    setLoading(true);
  };

  const isBGImg =
    selectedCampaign?.background?.startsWith("http") ||
    selectedCampaign?.background?.startsWith("/") ||
    selectedCampaign?.background?.startsWith("media");

  return (
    <div
      className="video-block section-padding"
      style={{
        maxWidth: "100%",
        margin: "0px",
      }}
    >
      <div
        style={{
          position: "relative",
          padding: "40px 40px 30px 40px",
          backgroundSize: "cover",
          backgroundPosition: "center",
          overflow: "hidden",
          backgroundColor: "#e9ecef",
          ...(() => {
            const bg = selectedCampaign?.background;
            if (typeof bg === "string") {
              if (isBGImg) {
                return { backgroundImage: `url(${baseURL}${bg})` };
              } else {
                return { backgroundColor: bg };
              }
            }
            return { backgroundColor: "#e9ecef" };
          })(),
        }}
      >
        {isBGImg && (
          <div
            style={{
              position: "absolute",
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              backgroundColor: "rgba(0, 0, 0, 0.15)",
              pointerEvents: "none",
            }}
          />
        )}

        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            backgroundColor: "#fafafaab",
            padding: "10px 20px",
            borderRadius: "3px",
            boxShadow: "0px 0px 8px #fafafa9e",
          }}
        >
          <div>
            <h3
              style={{
                textAlign: "right",
                color: "#353535",
                fontSize: "22px",
                margin: "0px 0px 5px 0px",
              }}
            >
              {title}
            </h3>
            <h6
              style={{
                textAlign: "right",
                color: "#636262ff",
                fontSize: "18px",
                margin: "0px",
              }}
            >
              {selectedCampaign?.Terms_participation_in_campaign}
            </h6>
          </div>
          {isLoggedIn && (
            <div
              style={{
                display: "flex",
                flexDirection: "column",
              }}
            >
              <div
                style={{
                  display: "flex",
                  justifyContent: "left",
                  gap: "4px",
                }}
              >
                <button
                  style={{ padding: "5px", backgroundColor: "teal" }}
                  className="adminMoreEdit"
                  title="افزودن ویدئو به پویش"
                  onClick={() => setShowCampaignAdd(true)}
                >
                  <FontAwesomeIcon icon={faPlus} />
                </button>
                <Link
                  to={`/campaign-result/${selectedCampaign?.id}`}
                  style={{ padding: "5px", backgroundColor: "teal" }}
                  className="adminMoreEdit resultBtn"
                  title="مشاهده نتیجه"
                >
                  <FontAwesomeIcon icon={faTrophy} />
                </Link>
              </div>
            </div>
          )}
        </div>
        <Row className="gx-3 gy-4" style={{ padding: "40px 10px 0px 10px" }}>
          {visibleVideos?.length !== 0 &&
            visibleVideos?.map((item, index) => (
              <Col
                key={index}
                xs={12}
                sm={6}
                md={4}
                lg={3}
                xl={2}
                className="mb-3 px-1"
              >
                {type === "channel" ? (
                  <ChannelCard
                    total_video_count={item?.total_video_count}
                    imgSrc={item?.avatar}
                    views={item?.counted_view || 0}
                    videoViews={item?.total_video_views || 0}
                    channelName={item?.name}
                    subscriberCount={item?.subscribe_count || 0}
                    videosId={item?.name}
                    imgHref={`/single-channel/${item?.id}`}
                    channelHref={`/single-channel/${item?.id}`}
                    channelId={item?.id}
                    moreAdress={`/myVideos/${item?.id}`}
                  />
                ) : (
                  <VideoCard
                    imgSrc={item?.cover ? item?.cover : "img/v4.png"}
                    videoTitle={item.title}
                    videoCategory={item.categorys?.name}
                    views={item.counted_views}
                    timeAgo={item.published_date}
                    verified
                    channelName={item.channel?.name}
                    channelId={item.channel?.id}
                    imgHref={`/video-page/${item.id}/?campaign=${item.campaign.id}&category=${item.categorys.id}`}
                    iconHref={`/video-page/${item.id}/?campaign=${item.campaign.id}&category=${item.categorys.id}`}
                    videoTitleHref={`/video-page/${item.id}/?campaign=${item.campaign.id}&category=${item.categorys.id}`}
                    mine={mine}
                    videoId={item?.id}
                    campaign={true}
                    videoPublisher={
                      item?.publisher?.first_name +
                      " " +
                      item?.publisher?.last_name
                    }
                  />
                )}
              </Col>
            ))}
        </Row>
      </div>

      <Modal isOpen={showCampaignAdd} onClose={() => setShowCampaignAdd(false)}>
        <CategoryContextProvider>
          <TagsContextProvider>
            <AddVideoToCampaignForm
              handleUploadClick={handleUploadClick}
              loading={loading}
              setLoading={setLoading}
              campaignId={selectedCampaign?.id}
              progress={progress}
              setProgress={setProgress}
              onClose={() => setShowCampaignAdd(false)}
            />
          </TagsContextProvider>
        </CategoryContextProvider>
        {loading && (
          <div
            style={{
              paddingTop: "30px",
              paddingLeft: "30px",
              paddingRight: "30px",
            }}
          >
            <hr />
            <Row>
              <Col lg={12}>
                <div className="rtlByMe">
                  <HeadingWrapper heading="بارگزاری جزئیات" />
                </div>
              </Col>
              <Col lg={2}>
                <div className="imgplace"></div>
              </Col>

              <Col lg={10} style={{ textAlign: "right" }}>
                <div className="osahan-title">در حال ارسال...</div>
                <div className="osahan-progress">
                  <ProgressBar striped animated now={progress} />

                  <div className="osahan-close">
                    <a
                      onClick={() => {
                        setLoading(false);
                        setProgress(0); // Reset progress
                      }}
                      style={{ cursor: "pointer" }}
                    >
                      <FontAwesomeIcon icon={faTimesCircle} />
                    </a>
                  </div>
                </div>
                <div className="osahan-desc">
                  ویدئو درحال بارگزاری می باشد، لطفا صفحه را نبندید.
                </div>
              </Col>
            </Row>
          </div>
        )}
      </Modal>
    </div>
  );
};

export default Campaign;
